import { AppLayout } from "@/components/AppLayout";

export default function About() {
  return (
    <AppLayout currentPage="about">
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 pt-8 pb-8 max-w-4xl">
          <h1 className="text-4xl font-bold text-foreground mb-4">About Us</h1>
          <p className="text-xl text-muted-foreground">
            TailorWiz is changing how job seekers land interviews—one tailored resume at a time.
          </p>
        </div>
        
        <main className="container mx-auto px-4 py-8 max-w-4xl">
          <div className="prose prose-lg mx-auto">
            <section className="mb-12">
              <p className="text-lg text-muted-foreground leading-relaxed">
                We built TailorWiz for the job seeker who's tired of applying and hearing nothing back. Our platform helps you tailor your resume, cover letter, and LinkedIn profile to match exactly what recruiters and applicant tracking systems (ATS) are looking for—quickly, accurately, and honestly.
              </p>
              
              <p className="text-lg text-muted-foreground leading-relaxed">
                We're not just another resume builder. We're a precision tailoring platform designed to help your unique experience align with real job requirements in real time. Our smart system extracts and ranks the most important skills, responsibilities, and requirements from any job description—then rewrites your resume content to match.
              </p>
              
              <p className="text-lg text-muted-foreground leading-relaxed font-medium">
                No keyword stuffing. No gimmicks. Just better targeting and better outcomes.
              </p>
            </section>

            <section className="mb-12">
              <div className="flex items-center gap-2 mb-4">
                <span className="text-2xl">🎯</span>
                <h2 className="text-2xl font-bold text-foreground">Our Mission</h2>
              </div>
              <p className="text-lg text-muted-foreground">
                To help professionals at every stage of their career get seen, get interviews, and get hired—faster.
              </p>
            </section>

            <section className="mb-12">
              <div className="flex items-center gap-2 mb-4">
                <span className="text-2xl">🛠️</span>
                <h2 className="text-2xl font-bold text-foreground">What We Do</h2>
              </div>
              <ul className="space-y-3 text-lg text-muted-foreground">
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1">•</span>
                  Resume tailoring powered by real job data
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1">•</span>
                  ATS-friendly formatting with no fluff
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1">•</span>
                  Customization for job titles, industries, or specific job descriptions
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1">•</span>
                  Tools that show how well you match a job before you apply
                </li>
              </ul>
            </section>

            <section className="mb-12">
              <div className="flex items-center gap-2 mb-4">
                <span className="text-2xl">🤝</span>
                <h2 className="text-2xl font-bold text-foreground">Who We Serve</h2>
              </div>
              <p className="text-lg text-muted-foreground">
                Whether you're a recent grad, a career changer, or an executive aiming for your next role—TailorWiz is built to help you move forward with clarity, speed, and confidence.
              </p>
            </section>

            <section className="mb-12">
              <div className="flex items-center gap-2 mb-4">
                <span className="text-2xl">🙌</span>
                <h2 className="text-2xl font-bold text-foreground">Why We Built It</h2>
              </div>
              <div className="space-y-4 text-lg text-muted-foreground">
                <p>Because job boards are crowded. And resumes that aren't tailored often get buried.</p>
                <p>We wanted a tool that made it easy to personalize every application—and do it in minutes, not hours.</p>
              </div>
            </section>

            <section className="text-center py-8 border-t border-border">
              <h3 className="text-2xl font-bold text-primary mb-2">TailorWiz</h3>
              <p className="text-lg text-muted-foreground italic">One resume. Many opportunities.</p>
            </section>
          </div>
        </main>
      </div>
    </AppLayout>
  );
}
